<template>
    <div class="notice-table">
        <el-table
            height="200"
            class="recent-news-table"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="subject"
                :label="$translate('lang.E3202103170007', { defaultText: '标题' })">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.subject" placement="top-start">
                        <span>{{scope.row.subject}}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                :label="$translate('lang.E3202103170008', { defaultText: '维护类型' })">
                <template slot-scope="scope">
                    <span >
                    {{maintenanceType(scope.row.contentType)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                :label="$translate('lang.E3202101250010', { defaultText: '状态' })">
                <template slot-scope="scope">
                    <span :style="{color:scope.row.state===0?'':'red'}">
                    {{state(scope.row.state)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="createUserCode"
                :label="$translate('lang.E3202102250026', { defaultText: '创建人' })">
            </el-table-column>
            <el-table-column
                sortable
                prop="createTime"
                :label="$translate('lang.E3202102250027', { defaultText: '创建时间' })">
            </el-table-column>
            <el-table-column
                prop="createUserCode"
                :label="$translate('lang.E3202103020006', { defaultText: '更新人' })">
            </el-table-column>
            <el-table-column
                sortable
                prop="updateTime"
                :label="$translate('lang.E3202101250011', { defaultText: '更新时间' })">
            </el-table-column>
            <el-table-column :label="$translate('lang.E3202101250007', { defaultText: '操作' })" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="indexState(scope.row)">
                        {{handleState(scope.row.state)}}
                    </el-button>
                    <el-button type="text" @click="changeNews(scope.row)">
                        {{$translate('lang.E3202102260009', { defaultText: '编辑' })}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
const CONTENT_TYPE = { // 维护类型
    '1': '最新公告',
    '2': '常见问题',
    '3': '内销公告',
    '4': '外销公告'
};
export default {
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    computed: {
        handleState() {
            return (flag) => {
                if (flag === 0) {
                    return this.$translate('lang.E3202102260003', { defaultText: '停用' });
                } else {
                    return this.$translate('lang.E3202102260004', { defaultText: '启用' });
                }
            };
        },
        maintenanceType() {
            return (flag) => {
                return CONTENT_TYPE[flag];
            };
        },
        state() {
            return (flag) => {
                if (flag === 0) {
                    return this.$translate('lang.E3202103170020', { defaultText: '已启用' });
                } else {
                    return this.$translate('lang.E3202103170021', { defaultText: '已停用' });
                }
            };
        }
    },
    methods: {
        indexState(row) {
            this.$emit('changeStauts', row);
        },
        changeNews(row) {
            this.$emit('changeNews', row);
        }
    }
};
</script>
<style lang="less">
.notice-table{
     .el-table--border {
        border: 1px solid #EBEEF5;
    }
}
</style>